import { TeflLecComment } from '../../../lib/types/models/tefl-lec-comment/tefl-lec-comment'
import { TeflLecCommentInput } from '../../../lib/types/models/tefl-lec-comment/tefl-lec-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createTeflLecComment = async (input: TeflLecCommentInput & { teflId: number }) => {
  const { teflId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.tefl.createTeflLecComment.url, { teflId }))
    .post<TeflLecComment, TeflLecCommentInput>(data)
}
